import { Link } from 'gatsby';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import React, { useEffect, useRef, useState } from 'react';
import NKLogo from '../svgs/NKLogo';
import NKMobileLogo from '../svgs/NKLogoMobile';
import Hamburger from './Hamburger';
import {
  desktopLogo,
  desktopNav,
  linksContainer,
  logoWrapper,
  mobileLogo,
  mobileNav,
  navBar,
  navWrapper,
  skipLink,
} from './Header.module.scss';
import NavDrawer from './NavDrawer';
gsap.registerPlugin(ScrollTrigger);

const Header = () => {
  const navRef = useRef();

  const navDrawerRef = useRef(null);
  const [navDrawerOpen, setNavDrawerOpen] = useState(false);

  const toggleNavDrawer = () => {
    setNavDrawerOpen(!navDrawerOpen);
  };

  useEffect(() => {
    if (navDrawerOpen) {
      // Update the aria-expanded attribute
      // navDrawerRef.current.setAttribute('aria-expanded', true);
      document.body.style.overflowY = 'hidden';
    } else if (!navDrawerOpen) {
      // Update the aria-expanded attribute
      // navDrawerRef.current.setAttribute('aria-expanded', false);
      document.body.style.overflowY = 'unset';
    }
  }, [navDrawerOpen]);

  const focusMainContent = () => {
    document.querySelector('#main').focus();
  };

  return (
    <header className={`${navWrapper} pagePadding pageGrid`}>
      <Link
        to="#main"
        className={`nav srOnly textColorMilk ${skipLink}`}
        onClick={focusMainContent}
      >
        Skip to Content
      </Link>
      <nav
        className={`gridAllColumns`}
        ref={navRef}
        aria-label="main navigation"
        data-scroll-lock-fill-gap // prevent the hamburger from shifting
      >
        <div className={`${navBar} `}>
          <Link to={`/`} className={`${logoWrapper}`}>
            <p className={`srOnly`}>Night Kitchen Interactive Homepage</p>
            <div className={`${desktopLogo}`}>
              <NKLogo />
            </div>
            <div className={`${mobileLogo}`}>
              <NKMobileLogo />
            </div>
          </Link>
          <ul className={`${desktopNav} ${linksContainer}`}>
            <li>
              <Link
                to={`/work`}
                className={`linkHoverOnly`}
                activeClassName={`linkStyle`}
                partiallyActive={true}
              >
                Work
              </Link>
            </li>
            <li>
              <Link
                to={`/approach`}
                className={`linkHoverOnly`}
                activeClassName={`linkStyle`}
                partiallyActive={true}
              >
                Approach
              </Link>
            </li>
            <li>
              <Link
                to={`/services`}
                className={`linkHoverOnly`}
                activeClassName={`linkStyle`}
                partiallyActive={true}
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to={`/about`}
                className={`linkHoverOnly`}
                activeClassName={`linkStyle`}
                partiallyActive={true}
              >
                About Us
              </Link>
            </li>
          </ul>
          <div className={`${mobileNav}`}>
            <Hamburger
              navDrawerOpen={navDrawerOpen}
              toggleNavDrawer={toggleNavDrawer}
            />
          </div>
        </div>

        <div
          id="navDrawer"
          ref={navDrawerRef}
          // aria-label="All Pages"
          // aria-expanded="false"
        >
          <NavDrawer
            navDrawerOpen={navDrawerOpen}
            toggleNavDrawer={toggleNavDrawer}
            setNavDrawerOpen={setNavDrawerOpen}
          />
        </div>
      </nav>
    </header>
  );
};

export default Header;
